import React from "react";

const MedicalPortalAccess = ({
  portalValue,
  onChange,
  isDisabled = false,
  label,
  id,
}) => {
  return (
    <div className="mb-4 grid grid-cols-1 sm:grid-cols-2 gap-2 items-center">
      <label
        htmlFor={id}
        className="block text-base font-medium text-black col-span-5"
      >
       {label}
      </label>
      <div className="col-span-5 flex items-center space-x-6">
        {[
          { value: "true", label: "Yes" },
          { value: "false", label: "No" },
        ].map((option) => (
          <label key={option.value} className="flex items-center">
            <input
              type="radio"
              id={id} // stays the same for grouping
              name={id} // ensures only one selected
              value={option.value}
              disabled={isDisabled}
              onChange={onChange}
              checked={String(portalValue) === option.value}
              className="form-radio h-5 w-5 border-gray-700 checked:bg-blue-600"
            />
            <span className="ml-2 text-base text-black">
              {option.label}
            </span>
          </label>
        ))}
      </div>
    </div>
  );
};

export default MedicalPortalAccess;
